module.exports = __webpack_public_path__ + "img/builder-9.8f2fc622.webp";